var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconHistoricalLogHover(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(2 3)"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#06749F",
    points: "0 3 12 3 12 0 0 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFF",
    points: "1 2 1 1 2 1 2 2"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#06749F",
    points: "0 7 12 7 12 4 0 4"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFF",
    points: "1 6 1 5 2 5 2 6"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#06749F",
    points: "0 11 12 11 12 8 0 8"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFF",
    points: "1 10 1 9 2 9 2 10"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHistoricalLogHover);
export default __webpack_public_path__ + "static/media/icon_historical_log_hover.e84e6886e237bf1d0c312d0e15e5c1e1.svg";
export { ForwardRef as ReactComponent };